import { ref, push } from "firebase/database";
import { auth, db } from "../../config/firebase";



/**
 * Logs an event to Firebase Realtime Database under the user's UID.
 * @param {string} event - A short event identifier (e.g. "upload_std_file")
 * @param {object} details - Additional custom details to log
 */
export function logUserEvent(event, details = {}) {
  const user = auth.currentUser;
  if (!user) return;

  const logRef = ref(db, `userLogs/${user.uid}`);
  push(logRef, {
    timestamp: Date.now(),
    event,
    ...details
  });
}